import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import { fetchRegulatorMe } from "./regulatorMeClient";
import type { RegulatorMe } from "./regulatorMeClient";

export const REGULATOR_ME_QUERY_KEY = ["regulator-portal", "me"] as const;

// Approval is granted operator-side, so the portal only learns about it by
// asking again. Short enough that a regulator watching the holding screen sees
// it flip, long enough not to hammer `/me`.
export const REGULATOR_ME_PENDING_POLL_MS = 15000;

/** Poll while the regulator waits on approval; stop once `/me` settles. */
export const resolveRegulatorMeRefetchInterval = (
  data: RegulatorMe | undefined,
): number | false =>
  data?.status === "pending" ? REGULATOR_ME_PENDING_POLL_MS : false;

export const useRegulatorMe = (
  enabled = true,
): UseQueryResult<RegulatorMe, Error> =>
  useQuery<RegulatorMe, Error>({
    queryKey: REGULATOR_ME_QUERY_KEY,
    queryFn: () => fetchRegulatorMe(),
    enabled,
    staleTime: 1000 * 10,
    refetchOnWindowFocus: false,
    retry: false,
    refetchInterval: (query) =>
      resolveRegulatorMeRefetchInterval(query.state.data),
  });
